import Vue from "vue";
import axios from "axios";
import VueCookies from 'vue-cookies';

let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";
export default {
  state: {
    userCart: [],
    userAddress: [],
    cartEmpty: false,
    cartError: false,
    recQuesOneError: false,
    recQuesByAgeError: false,
    answerCodeError: false,
    shopDetails: [],
    productDetails: [],
    individualProductDetail: [],
    individualProductDetailByCode: [],
    recEngineQuesOne: [],
    recEngineQuesByAge: [],
    answerCode: [],
    //otpStatus: false,
  },
  getters: {
    getUserCart: (state) => state.userCart,
    getUserAddress: (state) => state.userAddress,
    getCartEmpty: (state) => state.cartEmpty,
    getCartError: (state) => state.cartError,
    getRecAgeOptionError: (state) => state.recQuesByAgeError,
    getRecQuesOneError: (state) => state.recQuesOneError,
    getAnswerCodeError: (state) => state.answerCodeError,
    getShopDetails: (state) => state.shopDetails,
    getProductDetails: (state) => state.productDetails,
    getIndividualProductDetail: (state) => state.individualProductDetail,
    getIndividualProductDetailByCode: (state) => state.individualProductDetailByCode,
    getRecEngineQuesOne: (state) => state.recEngineQuesOne,
    getRecEngineQuesByAge: (state) => state.recEngineQuesByAge,
    getAnswerCode: (state) => state.answerCode

   // getOtpStatus: (state) => state.otpStatus,
  },
  actions: {
    checkPincode({ commit},pincode) {
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/externals/pincode/${pincode}`).then(response => {
          if(response.data.serviceAvailable == true)
              resolve('success')
          else
            reject(response.data)    
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchUserCart({ commit }) {
      axios.get(`${BASE_URL}/purchase/cart`).then((responseCartdetails) => {
          if(responseCartdetails.data.status == "success" && responseCartdetails.data.message == "No item in the cart."){
            commit("setEmptyCart")
          }else if(responseCartdetails.data.status == "success"){
            commit("setUserCart", responseCartdetails.data.data);
          }
      }).catch(error => {
        if(error.message !== "Request failed with status code 401") commit("setCartError")
      })
    },
    fetchUserAddress({commit}) {
      axios.get(`${BASE_URL}/purchase/address`).then(responseAddress => {
        commit("setUserAddress", responseAddress.data.data)
      })
    },
    updateCartQuantity({dispatch}, cartPayload) {
      axios.put(`${BASE_URL}/purchase/update/cartQuantity`,cartPayload).then(update => {
        dispatch('fetchUserCart')
      })
    },
    applyCoupon({commit},couponCode) {
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/purchase/cart/shipping/coupon/${couponCode}`).then(responseCartdetails => {
          commit("setUserCart", responseCartdetails.data.data);
          resolve(responseCartdetails.data.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateSelectedAddress({commit},addressId){
      axios.put(`${BASE_URL}/purchase/address`,addressId).then(response => {})
    },
    addUserAddress({dispatch},addressPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/purchase/address`,addressPayload).then(response => {
          dispatch("fetchUserAddress")
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    addUserReview({dispatch},reviewPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/reviews`,reviewPayload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchShippingCharges({commit}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/purchase/cart/shipping`).then(cartResponse => {
          commit('setUserCart', cartResponse.data.data)
          resolve("success")
        }).catch(error => {
          reject(error)
        })
      })
    },
    removeProduct({dispatch},productCode){
      axios.put(`${BASE_URL}/purchase/cart`,productCode).then(response => {
        dispatch("fetchUserCart")
      })
    },
    fetchLogoutItemDetails({commit}){
      return new Promise((resolve,reject) => {
        const userItem = JSON.parse(Vue.$cookies.get("userCart"))
        if(userItem.length > 0){
          axios.post(`${BASE_URL}/purchase/items/details`,{items: userItem}).then(responseCartdetails => {
            commit("setUserCart", responseCartdetails.data.data);
            resolve(responseCartdetails.data.data)
          }).catch(error => {
              reject(error)
          })
        }else{
          Vue.$cookies.remove("userCart")
          commit("setEmptyCart")
        }
      })
    },
    addGuestuser({commit},guestUserPayload){
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_URL}/purchase/guest/user`,guestUserPayload).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    sendOTP({commit},phoneNo){
      var otp = Math.floor(100000 + Math.random() * 900000)
      var otpPayload = {
        "action": "verify",
        "phone": phoneNo,
        "code": otp
      }
      return new Promise((resolve,reject) => {
        if(process.env.VUE_APP_SERVER_TYPE == "SERVER"){
          axios.post(`${BASE_URL}/externals/message/otp`,otpPayload).then(optResponse => {
            localStorage.setItem('otp', otp)
            localStorage.setItem('phone',phoneNo)
            resolve(optResponse.data)
          }).catch(error => {
            reject(error)
          })
        }else{
          console.log(otp)
          localStorage.setItem('otp', otp)
          localStorage.setItem('phone',phoneNo)
          resolve("success")
        }
      })
    },
    addGuestUserCartDetail({commit}, guestUserPayload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/purchase/cart/guest`,guestUserPayload).then(response => {
          Vue.$cookies.set("guestAccess",response.data.token)
          resolve("success")
        }).catch(error => {
          reject(error)
        })
      })
    },
    fetchproductDetailsByUri({commit},productUri){
      axios.get(`${BASE_URL}/products/uri/${productUri}`).then(productResponse => {
        commit("setIndividualProductDetail",productResponse.data.data)
      }).catch(error => {
        commit("setCartError")
      }) 
    },
    fetchShopPageDetails({commit}){
      axios.get(`${BASE_URL}/testimonials/shop`).then(shopResponse => {
          commit('shopDetails',shopResponse.data)
      })
    },
    fetchAllProducts({commit}){
      axios.get(`${BASE_URL}/products/category/product`).then(productResponse => {
        commit("setProductDetails",productResponse.data.data)
      }).catch(error => {
        commit("setCartError")
      })
    },
    addItemToCart({dispatch},productPayLoad){
      axios.post(`${BASE_URL}/purchase/cart`,productPayLoad).then(response => {
        dispatch("fetchUserCart")
      })
    },
    fetchRecEngineQuestionByAge({commit},ageOption){
      axios.get(`${BASE_URL}/products/age/${ageOption}`).then(productRecEngineResponse => {
        // console.log(productRecEngineResponse.data.data)
        commit("setRecEngineQuesByAge",productRecEngineResponse.data.data)
      }).catch(error => {
        commit("setRecAgeOptionError")
      }) 
    },
    fetchRecEngineQuestionOne({commit}){
      axios.get(`${BASE_URL}/products/questionLevelOne`).then(productRecEngineQuesOneResponse => {
        commit("setRecEngineQuesOne",productRecEngineQuesOneResponse.data.data.question_level_1)
        // console.log(productRecEngineQuesOneResponse.data.data)
      }).catch(error => {
        commit("setRecQuesOneError")
      }) 
    },
    fetchProductByRecEngineCode({commit},answerCode){
      axios.get(`${BASE_URL}/products/fetchProductByRecEngineCode/${answerCode}`).then(productCodeRecEngineResponse => {
        if(productCodeRecEngineResponse.data.data[0].product_code.trim()!=='beginner-coding-app-dev-micro-degree'){
        axios.get(`${BASE_URL}/products/uri/${productCodeRecEngineResponse.data.data[0].product_code}`).then(productResponse => {
          productResponse.data.data['product_type']='product';
          commit("setAnswerCode",productResponse.data.data)
        })}else{
          axios.get(`https://cloud.ircleague.com/api/curriculum/course/codeDetails/${productCodeRecEngineResponse.data.data[0].product_code}`).then(productResponse => {
            productResponse.data.course_data['product_type']='course';  
          commit("setAnswerCode",productResponse.data.course_data)
          })
        }
      }).catch(error => {
        commit("setAnswerCodeError")
      }) 
    },

  },
  mutations: {
    setUserCart: (state, cartData) => {
      state.userCart = cartData
      state.cartEmpty = false
    },
    setUserAddress: (state, addressData) => (state.userAddress = addressData),
    setEmptyCart: (state) => {
      state.cartEmpty = true
      state.userCart = []
    },
    setCartError: (state) => (state.cartError = true),
    setRecAgeOptionError: (state) => (state.recQuesByAgeError = true),
    setRecQuesOneError: (state) => (state.recQuesOneError = true),
    setAnswerCodeError: (state) => (state.answerCodeError = true),
    shopDetails: (state,shopData) => (state.shopDetails = shopData),
    setProductDetails: (state,productdata) => (state.productDetails = productdata),
    setIndividualProductDetail: (state,productdata) => (state.individualProductDetail = productdata),
    setIndividualProductDetailByCode: (state,productdata) => (state.individualProductDetailByCode = productdata),
    setRecEngineQuesOne: (state,recQuesOne) => (state.recEngineQuesOne = recQuesOne),
    setRecEngineQuesByAge: (state,recQuesAge) => (state.recEngineQuesByAge = recQuesAge),
    setAnswerCode: (state,fetchAnswerCode) => (state.answerCode = fetchAnswerCode),

  },
};
